<app-game-data-logs-popup (dataUpdated)="onDataUpdated()"></app-game-data-logs-popup>

<p-dialog
  header="Release Notes"
  [(visible)]="showReleaseNotesModal"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '55vw' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }"
>
  <div *ngIf="releaseNotesLoading" style="text-align: center; padding: 2em;">
    <i class="pi pi-spin pi-spinner" style="font-size: 2em;"></i>
  </div>

  <ng-container *ngIf="!releaseNotesLoading">
    <pre style="white-space: pre-wrap; word-break: break-word; font-family: inherit; font-size: 0.9em; line-height: 1.6; margin: 0 0 1em 0;">{{ releaseNotesContent }}</pre>

    <ng-container *ngIf="diffTables.length > 0">
      <button
        pButton
        type="button"
        [label]="showUpdatedRows ? 'Hide Updated Rows' : 'Show Updated Rows'"
        [icon]="showUpdatedRows ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        iconPos="right"
        class="p-button-outlined p-button-sm"
        style="margin-bottom: 0.75em;"
        (click)="showUpdatedRows = !showUpdatedRows"
      ></button>

      <div *ngIf="showUpdatedRows">
        <div *ngFor="let table of diffTables" style="margin-bottom: 0.5em; border: 1px solid var(--surface-border); border-radius: 4px; overflow: hidden;">
          <div
            (click)="toggleTable(table.name)"
            style="display: flex; justify-content: space-between; align-items: center; padding: 0.5em 0.75em; background: var(--surface-ground); cursor: pointer; font-weight: 600; font-size: 0.85em;"
          >
            <span>{{ table.name }} <span style="font-weight: 400; color: var(--text-color-secondary);">({{ table.rows.length }}{{ table.isTruncated ? '+' : '' }} rows)</span></span>
            <i [class]="expandedTables[table.name] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="font-size: 0.75em;"></i>
          </div>

          <div *ngIf="expandedTables[table.name]" style="padding: 0.5em 0.75em;">
            <div *ngFor="let row of table.rows" style="margin-bottom: 0.6em; padding-bottom: 0.6em; border-bottom: 1px solid var(--surface-border); font-size: 0.82em;">
              <span style="font-weight: 600;">{{ table.name }} ID ({{ row.id }})</span>
              <div *ngFor="let field of objectKeys(row.changes)" style="margin-top: 0.2em; padding-left: 0.75em; color: var(--text-color-secondary);">
                <span style="color: var(--text-color);">{{ field }}</span>:
                <span style="color: #e57373;">{{ row.changes[field].old | json }}</span>
                <span style="margin: 0 0.3em;">→</span>
                <span style="color: #81c784;">{{ row.changes[field].new | json }}</span>
              </div>
            </div>
            <div *ngIf="table.isTruncated" style="font-size: 0.8em; color: var(--text-color-secondary); font-style: italic;">
              Showing first {{ table.rows.length }} rows — truncated
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</p-dialog>

<app-ag-grid-table
  #agGrid  
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [buildParams]="buildParams"
  [rowModelType]="'serverSide'"
>
</app-ag-grid-table>

  